// eslint-disable-next-line import/prefer-default-export
export const ProductFilterAccessibilityLabels = {
  global: {
    accessibility: {
      lbl_out_of: 'out of',
      lbl_rating: 'rating',
    },
  },
};
